module.exports = __webpack_public_path__ + "media/img/pages/companies/uni-basel-c19c38e30c65cd5ec8bb52859323b88b.webp";